<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-5" v-if="user_type == 'superadmin'">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-5 mb-5 mx-auto" v-if="loading">
              <div class="col-12 p-5 m-4 text-center">
                <div
                  class="spinner-border text-secondary"
                  role="status"
                  v-if="loading"
                >
                  <span class="sr-only">Loading..</span>
                </div>
              </div>
            </div>
            <div v-if="!loading">
              <b-button
                @click="addAdminModal"
                variant="success"
                class="btn mr-1"
                size="sm"
              >
                {{ $t("button.add.text") }}
                <i class="mdi mdi-plus mr-1"></i>
              </b-button>

              <b-modal
                id="modal-add"
                centered
                bordered
                size="lg"
                :title="$t('button.add.text')"
                title-class="font-18"
                :ok-title="$t('button.save.text')"
                :cancel-title="$t('button.cancel.text')"
              >
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="validationCustom01"
                        >{{ $t("admin-management.name") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        id="validationCustom01"
                        type="text"
                        class="form-control"
                        :placeholder="$t('admin-management.name')"
                        v-model="form.admin.name"
                        :class="{
                          'is-invalid': submitted && $v.form.admin.name.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.form.admin.name.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.admin.name.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="validationCustom01">{{
                        $t("admin-management.phone")
                      }}</label>
                      <input
                        id="validationCustom01"
                        type="text"
                        class="form-control"
                        placeholder="+62xxx"
                        v-model="form.admin.phone"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="validationCustom01"
                        >{{ $t("admin-management.email") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        id="validationCustom01"
                        type="text"
                        class="form-control"
                        :placeholder="$t('admin-management.email')"
                        v-model="form.admin.email"
                        :class="{
                          'is-invalid': submitted && $v.form.admin.email.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.form.admin.email.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.admin.email.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="validationCustom01"
                        >{{ $t("admin-management.password") }}
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        id="validationCustom01"
                        type="password"
                        class="form-control"
                        :placeholder="$t('admin-management.password')"
                        v-model="form.admin.password"
                        :class="{
                          'is-invalid':
                            submitted && $v.form.admin.password.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.form.admin.password.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.admin.password.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="validationCustom01"
                        >{{ $t("admin-management.role") }}
                        <span class="text-danger">*</span>
                      </label>
                      <select
                        class="form-control"
                        v-model="form.admin.role"
                        :class="{
                          'is-invalid': submitted && $v.form.admin.role.$error,
                        }"
                      >
                        <option value="">
                          {{ $t("user-management.select-role") }}
                        </option>
                        <option value="superadmin">Super Admin</option>
                        <option value="admin">Admin</option>
                      </select>
                      <div
                        v-if="submitted && $v.form.admin.role.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.admin.role.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="validationCustom01"
                        >{{ $t("admin-management.active") }}
                        <span class="text-danger">*</span>
                      </label>
                      <select
                        class="form-control"
                        v-model="form.admin.active"
                        :class="{
                          'is-invalid':
                            submitted && $v.form.admin.active.$error,
                        }"
                      >
                        <option value="1">
                          {{ $t("user-management.active") }}
                        </option>
                        <option value="0">
                          {{ $t("user-management.deactive") }}
                        </option>
                      </select>
                      <div
                        v-if="submitted && $v.form.admin.active.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.admin.active.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="validationCustom01"
                        >{{ $t("departments.department") }}
                        <span class="text-danger">*</span>
                      </label>
                      <select
                        class="custom-select"
                        v-model="form.admin.id_dep"
                        :class="{
                          'is-invalid': submitted && $v.form.admin.id_dep.$error,
                        }"
                      >
                        <option
                            v-for="rg in tableDataDapertement"
                            :key="rg.id_dep"
                            :value="rg.id_dep"
                          >{{rg.dep_name}}
                        </option>
                      </select>
                      <div
                        v-if="submitted && $v.form.admin.id_dep.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.form.admin.id_dep.required">{{
                          $t("form.error.text")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <small class="text-danger ml-3 mt-2"
                      >* {{ $t("error.is-required") }} |
                      {{ $t("error.is-password") }}</small
                    >
                  </div>
                </div>
                <template #modal-footer="{ cancel }">
                  <b-button
                    size="md"
                    variant="danger"
                    @click="cancel()"
                    :class="{ 'disabled ': loading_add }"
                  >
                    {{ $t("button.cancel.text") }}
                  </b-button>
                  <b-button
                    size="md"
                    variant="success"
                    @click="addAdmin"
                    :class="{ 'disabled ': loading_add }"
                  >
                    <b-spinner
                      variant="light"
                      small
                      v-if="loading_add"
                    ></b-spinner>
                    {{ $t("button.save.text") }}
                  </b-button>
                </template>
              </b-modal>

              <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mr-1">
                      <span class="mr-2"> {{ $t("tables.show") }}</span>
                      <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                      <span class="ml-2">{{ $t("tables.entries") }}</span>
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      {{ $t("tables.search") }}:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        :placeholder="$t('tables.search')"
                        class="form-control form-control-sm ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  :items="tableData"
                  :fields="fields"
                  bordered
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <template #cell(login)="row">
                    <div>
                      <span
                        class="btn btn-success rounded-pill btn-sm"
                        v-if="row.item.login == 1"
                      >
                        Login</span
                      >
                      <span
                        class="btn btn-danger rounded-pill btn-sm"
                        v-if="row.item.login == 0"
                      >
                        {{ $t("admin-management.not-login") }}</span
                      >
                      <br />
                      <small
                        >{{ $t("admin-management.login-ip-address") }} :
                        {{ ipconvert(row.item.log_ipaddr, false) }}</small
                      >
                    </div>
                  </template>
                  <template #cell(active)="row">
                    <div>
                      <span
                        class="btn btn-success rounded-pill btn-sm"
                        v-if="row.item.active == 1"
                      >
                        {{ $t("user-management.active") }}</span
                      >
                      <span
                        class="btn btn-danger rounded-pill btn-sm"
                        v-if="row.item.active == 0"
                      >
                        {{ $t("user-management.deactive") }}</span
                      >
                    </div>
                  </template>
                  <template #cell(role)="row">
                    <div>
                     <span>{{row.item.role}}</span> <br>
                     <small class="text-primary" v-if="row.item.department">({{row.item.department.dep_name}})</small>
                    </div>
                  </template>
                  <template #cell(action)="row">
                    <div>
                      <b-button
                        size="sm"
                        variant="info"
                        class="mr-1 mb-1"
                        @click="resetModal(row.item.id_admin)"
                        ><i class="fas fa-key"></i
                      ></b-button>
                      <b-button
                        size="sm"
                        variant="info"
                        class="mr-1 mb-1"
                        @click="editAdmin(row.item)"
                        ><i class="fas fa-pencil-alt"></i
                      ></b-button>
                      <b-button
                        size="sm"
                        variant="danger"
                        class="mb-1"
                        @click="deleteAdmin(row.item.id_admin, row.item.name)"
                        ><i class="fas fa-trash"></i
                      ></b-button>

                      <b-modal
                        ref="ref-modal-password"
                        :id="'modal-password' + row.item.id_admin"
                        centered
                        :title="$t('button.reset.text')"
                        title-class="font-17"
                        :ok-title="$t('button.reset.text')"
                        :cancel-title="$t('button.cancel.text')"
                      >
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="validationCustom01">{{
                                $t("admin-management.password")
                              }} <small class="text-danger">*</small></label>
                              <input
                                id="validationCustom01"
                                type="password"
                                class="form-control"
                                :placeholder="$t('admin-management.password')"
                                v-model="form.admin.password"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.form.admin.password.$error,
                                }"
                              />
                              <div
                                v-if="
                                  submitted && $v.form.admin.password.$error
                                "
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.admin.password.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="validationCustom01">{{
                                $t("admin-management.conf_password")
                              }}<small class="text-danger"> *</small></label>
                              <input
                                id="validationCustom01"
                                type="password"
                                class="form-control"
                                :placeholder="
                                  $t('admin-management.conf_password')
                                "
                                v-model="form.admin.conf_password"
                                :class="{
                                  'is-invalid':
                                    submitted &&
                                    $v.form.admin.conf_password.$error,
                                }"
                              />
                              <div
                                v-if="
                                  submitted &&
                                  $v.form.admin.conf_password.$error
                                "
                                class="invalid-feedback"
                              >
                                <span
                                  v-if="!$v.form.admin.conf_password.required"
                                  >{{ $t("form.error.text") }}</span
                                >
                                <span
                                  v-if="
                                    form.admin.conf_password &&
                                    !$v.form.admin.conf_password.sameAsPassword
                                  "
                                  >{{ $t("form.error.text2") }}</span
                                >
                              </div>
                            </div>
                          </div>
                          <small class="text-danger ml-3 mt-2">* {{ $t("error.is-password") }}</small>
                        </div>
                        <template #modal-footer="{ cancel }">
                          <b-button
                            size="md"
                            variant="danger"
                            @click="cancel()"
                            :class="{ 'disabled ': loading_add }"
                          >
                            {{ $t("button.cancel.text") }}
                          </b-button>
                          <b-button
                            size="md"
                            variant="success"
                            @click="
                              resetPasswordAdmin($event, row.item.id_admin)
                            "
                            :class="{ 'disabled ': loading_add }"
                          >
                            <b-spinner
                              variant="light"
                              small
                              v-if="loading_add"
                            ></b-spinner>
                            {{ $t("button.reset.text") }}
                          </b-button>
                        </template>
                      </b-modal>
                      <b-modal
                        ref="ref-modal-edit"
                        :id="'modal-edit' + row.item.id_admin"
                        centered
                        size="lg"
                        :title="$t('button.update.text')"
                        title-class="font-17"
                        :ok-title="$t('button.update.text')"
                        :cancel-title="$t('button.cancel.text')"
                      >
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="validationCustom01"
                                >{{ $t("admin-management.name") }}
                                <span class="text-danger">*</span>
                              </label>
                              <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('admin-management.name')"
                                v-model="form.admin.name"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.form.admin.name.$error,
                                }"
                              />
                              <div
                                v-if="submitted && $v.form.admin.name.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.admin.name.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="validationCustom01">{{
                                $t("admin-management.phone")
                              }}</label>
                              <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                placeholder="+62xxx"
                                v-model="form.admin.phone"
                              />
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="validationCustom01"
                                >{{ $t("admin-management.email") }}
                                <span class="text-danger">*</span>
                              </label>
                              <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('admin-management.email')"
                                v-model="form.admin.email"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.form.admin.email.$error,
                                }"
                              />
                              <div
                                v-if="submitted && $v.form.admin.email.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.admin.email.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="validationCustom01"
                                >{{ $t("admin-management.role") }}
                                <span class="text-danger">*</span>
                              </label>
                              <select
                                class="form-control"
                                v-model="form.admin.role"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.form.admin.role.$error,
                                }"
                              >
                                <option value="">
                                  {{ $t("user-management.select-role") }}
                                </option>
                                <option value="superadmin">Super Admin</option>
                                <option value="admin">Admin</option>
                              </select>
                              <div
                                v-if="submitted && $v.form.admin.role.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.admin.role.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="validationCustom01"
                                >{{ $t("admin-management.active") }}
                                <span class="text-danger">*</span>
                              </label>
                              <select
                                class="form-control"
                                v-model="form.admin.active"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.form.admin.active.$error,
                                }"
                              >
                                <option value="1">
                                  {{ $t("user-management.active") }}
                                </option>
                                <option value="0">
                                  {{ $t("user-management.deactive") }}
                                </option>
                              </select>
                              <div
                                v-if="submitted && $v.form.admin.active.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.admin.active.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="validationCustom01"
                                >{{ $t("departments.department") }}
                                <span class="text-danger">*</span>
                              </label>
                              <select
                                class="custom-select"
                                v-model="form.admin.id_dep"
                                :class="{
                                  'is-invalid': submitted && $v.form.admin.id_dep.$error,
                                }"
                              >
                                <option
                                    v-for="rg in tableDataDapertement"
                                    :key="rg.id_dep"
                                    :value="rg.id_dep"
                                  >{{rg.dep_name}}
                                </option>
                              </select>
                              <div
                                v-if="submitted && $v.form.admin.id_dep.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.form.admin.id_dep.required">{{
                                  $t("form.error.text")
                                }}</span>
                              </div>
                            </div>
                          </div>
                          <small class="text-danger ml-3 mt-2"
                            >* {{ $t("error.is-required") }} |
                            {{ $t("error.is-password") }}</small
                          >
                        </div>
                        <template #modal-footer="{ cancel }">
                          <b-button
                            size="md"
                            variant="danger"
                            @click="cancel()"
                            :class="{ 'disabled ': loading_add }"
                          >
                            {{ $t("button.cancel.text") }}
                          </b-button>
                          <b-button
                            size="md"
                            variant="success"
                            @click="updateAdmin($event, row.item.id_admin)"
                            :class="{ 'disabled ': loading_add }"
                          >
                            <b-spinner
                              variant="light"
                              small
                              v-if="loading_add"
                            ></b-spinner>
                            {{ $t("button.save.text") }}
                          </b-button>
                        </template>
                      </b-modal>
                    </div>
                  </template>
                </b-table>
              </div>

              <div class="row" v-if="tableData.length > 10">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import AdminService from "@/helpers/admin.service";
import UserService from "@/helpers/user.service";
import DepartmentService from "@/helpers/department.service";
import IpConvert from "@/helpers/ipconvert";
import { required, email, sameAs } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  page: {
    title: "Admin Management",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      user_type: "",
      tableData: [],
      tableDataDapertement: [],
      title: this.$t("settings.admins"),
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Setting",
          active: true,
        },
        {
          text: this.$t("settings.admins"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      form: {
        admin: {
          name: "",
          email: "",
          active: "1",
          role: "",
          phone: "",
          password: "",
          conf_password: "",
          nrp: "",
          id_dep:""
        },
      },
      loading: false,
      submitted: false,
      loading_add: false,
      fields: [
        { key: "name", sortable: true, label: "Name" },
        { key: "email", sortable: true, label: "Email" },
        { key: "active", sortable: true, label: "Active" },
        { key: "role", sortable: true, label: "Role" },
        { key: "login", sortable: true, label: "Login" },
        {
          key: "action",
          sortable: true,
          class: "text-center",
          label: this.$t("tables.action"),
        },
      ],
    };
  },
  validations: {
    form: {
      admin: {
        name: { required },
        email: { required },
        active: { required },
        role: { required },
        password: { required },
        id_dep: { required },
        conf_password: { required, sameAsPassword: sameAs("password") },
      },
    },
  },

  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  beforeMount() {
    this.userLogin();
    this.getDepartements();
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.getAdmin();
  },
  methods: {
    userLogin() {
      UserService.listProfile()
        .then((response) => {
          this.user_type = response.data.data.role;
        })
        .catch((e) => {
          this.message = e.response.data.data;
        });
    },
    getDepartements() {
      DepartmentService.listDepartement()
        .then((response) => {
            this.tableDataDapertement = [];
            this.tableDataDapertement = response.data.data;
            this.loading = false;
        })
        .catch((err) => {
            this.loading = false;
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getAdmin() {
      this.loading = true;
      AdminService.listAdmin()
        .then((response) => {
          this.tableData = [];
          this.tableData = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    getAdminUpdate() {
      AdminService.listAdmin()
        .then((response) => {
          this.tableData = [];
          this.tableData = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    addAdminModal() {
      this.$bvModal.show("modal-add");
      this.form.admin.name = "";
      this.form.admin.email = "";
      this.form.admin.active = "1";
      this.form.admin.role = "";
      this.form.admin.phone = "";
      this.form.admin.password = "";
      this.form.admin.id_dep = "";
    },

    addAdmin(e) {
      this.submitted = true;
      this.$v.form.admin.$touch();
      if (
        this.form.admin.name == "" ||
        this.form.admin.email == "" ||
        this.form.admin.role == "" ||
        this.form.admin.password == ""
      ) {
        e.preventDefault();
      } else {
        this.loading_add = true;
        const data = {
          name: this.form.admin.name,
          email: this.form.admin.email,
          active: this.form.admin.active,
          role: this.form.admin.role,
          phone: this.form.admin.phone,
          password: this.form.admin.password,
          id_dep: this.form.admin.id_dep,
        };
        // console.log(data);
        AdminService.addAdmin(data)
          .then((response) => {
            this.getAdminUpdate();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: "Add Admin Success",
              showConfirmButton: false,
              timer: 1500,
            });
            this.resetForm();
            this.$v.$reset();
            this.$bvModal.hide("modal-add");
            this.loading_add = false;
          })
          .catch((err) => {
            this.loading_add = false;
            Vue.swal({
              position: "top-end",
              icon: "error",
              title: err.response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          });
      }
    },

    editAdmin(data) {
      this.$bvModal.show("modal-edit" + data.id_admin);
      this.form.admin.name = data.name;
      this.form.admin.email = data.email;
      this.form.admin.active = data.active;
      this.form.admin.role = data.role;
      this.form.admin.phone = data.phone;
      this.form.admin.id_dep = data.id_dep;
      this.form.admin.password = data.password;
    },

    updateAdmin(e, uid) {
      this.submitted = true;
      this.$v.form.admin.$touch();
      if (
        this.form.admin.name == "" ||
        this.form.admin.email == "" ||
        this.form.admin.role == "" ||
        this.form.admin.id_dep == "" ||
        this.form.admin.password == ""
      ) {
        e.preventDefault();
      } else {
        this.loading_add = true;
        const data = {
          name: this.form.admin.name,
          email: this.form.admin.email,
          active: this.form.admin.active,
          role: this.form.admin.role,
          phone: this.form.admin.phone,
          id_dep: this.form.admin.id_dep,
        };
        AdminService.editAdmin(uid, data)
          .then((response) => {
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: response.data.message + " update admin",
              showConfirmButton: false,
              timer: 1500,
            });
            this.$bvModal.hide("modal-edit" + uid);
            this.getAdminUpdate();
            this.resetForm();
            this.$v.$reset();
            this.loading_add = false;
          })
          .catch((err) => {
            Vue.swal({
              position: "top-end",
              icon: "error",
              title: err.response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.$bvModal.hide("modal-edit" + uid);
            this.getAdminUpdate();
            this.resetForm();
            this.$v.$reset();
            this.loading_add = false;
          });
      }
    },

    resetModal(uid) {
      this.$bvModal.show("modal-password" + uid);
    },

    resetPasswordAdmin(e, uid) {
      this.submitted = true;
      this.$v.form.admin.password.$touch();
      this.$v.form.admin.conf_password.$touch();
      if (
        this.form.admin.password == "" ||
        this.form.admin.conf_password == "" ||
        this.$v.form.admin.conf_password.$error
      ) {
        e.preventDefault();
      } else {
        const data = {
          id_admin: uid,
          new_password: this.form.admin.password,
          confirm_password: this.form.admin.conf_password,
        };
        AdminService.resetPassword(data)
          .then((response) => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: response.data.message + " reset password",
              showConfirmButton: false,
              timer: 1500,
            });
            this.getAdminUpdate();
            this.resetForm();
            this.$v.$reset();
            this.loading_add = false;
          })
          .catch((err) => {
            this.loading_add = false;
            this.resetForm();
            this.$v.$reset();
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: err.response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          });
      }
    },

    deleteAdmin(uid, name) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[2]") + name + " ?",
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          AdminService.deleteAdmin(uid)
            .then((response) => {
              this.getAdminUpdate();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: err.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            });
        }
      });
    },

    resetForm() {
      setTimeout(() => {
        this.form.admin.name = "";
        this.form.admin.email = "";
        this.form.admin.active = "1";
        this.form.admin.role = "";
        this.form.admin.phone = "";
        this.form.admin.id_dep = "";
        this.form.admin.password = "";
        this.form.admin.conf_password = "";
      }, 2000);
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, HH:mm");
    },

    formatDateTimes(value) {
      var unixTime = value;
      var momentDate = moment.unix(unixTime),
        momentDay = momentDate.format("DD"),
        momentMonth = momentDate.format("MM"),
        momentYear = momentDate.format("YYYY"),
        momentHours = momentDate.format("HH"),
        momentMinutes = momentDate.format("mm"),
        momentSeconds = momentDate.format("ss");

      var t =
        '"' +
        momentYear +
        "-" +
        momentMonth +
        "-" +
        momentDay +
        " " +
        momentHours +
        ":" +
        momentMinutes +
        '"';
      var cdt = moment(t, "YYYY-MM-DD HH:mm");
      let a = this.formatDate(cdt);
      return a;
    },

    ipconvert(value, toDec) {
      if (toDec) {
        return IpConvert.ip2dec(value);
      } else {
        return IpConvert.dec2ip(value);
      }
    },
  },
};
</script>